module.exports = __webpack_public_path__ + "static/media/red-tag-sale-confirmation-background.cb784fc5.webp";